(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/button-choose-number.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/button-choose-number.js');

'use strict';

const Button = svs.ui.ReactButton;
const ButtonChooseNumbers = () => {
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_gameEntry',
      opt_label: 'Spela'
    }, () => {
      svs.utils.url.navigate('/lotto/spela');
    });
  };
  return React.createElement("div", {
    className: "button-wrapper js-button-wrapper"
  }, React.createElement("div", {
    className: "wrapper-body"
  }, React.createElement(Button, {
    block: true,
    className: "btn",
    onClick: handleClick,
    type: "button"
  }, "Spela egna nummer")));
};
setGlobal('svs.lotto.react.components', {
  ButtonChooseNumbers
});

 })(window);